import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
    selectLatestAchievements,
    selectLatestAchievementsLoaded,
    selectLatestAchievementsLoading,
    selectNextAchievement,
    selectNextAchievementLoaded,
    selectNextAchievementLoading,
} from '../selectors/achievement.selectors';
import { filter } from 'rxjs';
import { achievementActions } from '../actions/achievement.actions';

@Injectable({
    providedIn: 'root',
})
export class AchievementFacade {
    private readonly store = inject(Store);

    readonly nextAchievement$ = this.store.select(selectNextAchievement);
    readonly nextAchievementNonNullable$ = this.store.select(selectNextAchievement).pipe(filter((nextAchievement) => nextAchievement !== null));
    readonly nextAchievementLoaded$ = this.store.select(selectNextAchievementLoaded);
    readonly nextAchievementLoading$ = this.store.select(selectNextAchievementLoading);

    readonly latestAchievements$ = this.store.select(selectLatestAchievements);
    readonly latestAchievementsNonNullable$ = this.store.select(selectLatestAchievements).pipe(filter((latestAchievements) => latestAchievements !== null));
    readonly latestAchievementsLoaded$ = this.store.select(selectLatestAchievementsLoaded);
    readonly latestAchievementsLoading$ = this.store.select(selectLatestAchievementsLoading);

    getNextAchievement(): void {
        this.store.dispatch(achievementActions.getNextAchievement());
    }

    getLatestAchievements(): void {
        this.store.dispatch(achievementActions.getLatestAchievements());
    }

    clear(): void {
        this.store.dispatch(achievementActions.clear());
    }
}
